import { T } from "../Typography/T";

export function EmptyCell() {
  return (
    <T color="faint" size="xs">
      {"\u2014"}
    </T>
  );
}
